import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        state() {
            return {
                activity_id: null,
                activity_uuid: null,
                course_id: null,
                criterias: [],
                description: null,
                id: null,
                title: 'Grading Scheme',
                uuid: null,
            };
        },

        getters: {},

        actions: {},

        mutations: {},
    }
);
